var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("유효시간 "),_c('span',[_vm._v(_vm._s(_vm.padLeadingZeros( _vm.countminutes,2))+" : "+_vm._s(_vm.padLeadingZeros(_vm.countseconds,2)))]),_vm._v("초")])}
var staticRenderFns = []

export { render, staticRenderFns }